import base from "/app/images/sort.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");